import * as React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import Questions from "../pages/questions";
import Downloads from "../pages/downloads";
import Notifications from "../pages/notifications";
import Demos from "../pages/demos";
import ContactUs from "../pages/contactus";
import SignIn from "../pages/auth/signin";
import { getOnboarding, getUser } from "utils/service";
import SignUp from "../pages/auth/signup";
import VerifyOtp from "../pages/auth/verifyotp";
import ExamType from "../pages/auth/examtype";
import SelectGroup from "../pages/auth/selectgroup";
import SelectSubject from "../pages/auth/selectsubject";
import Account from "../pages/account/index";
import Profile from "pages/account/Profile";
import Payments from "pages/account/Payments";
import BookNPendrive from "pages/account/BookNPendrive";
import Subscriptions from "pages/account/Subscriptions";
import AddSubscription from "pages/account/AddSubscription";
import Coverage from "pages/coverage";
import Performance from "pages/performance";

const RouteFile = () => {
  const user = getUser();
  const onboardingData = getOnboarding();
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASE_PATH}>
      <Routes>
        {onboardingData ? (
          <>
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/exam-type" element={<ExamType />} />
            <Route path="/select-group" element={<SelectGroup />} />
            <Route path="/select-subject" element={<SelectSubject />} />
            <Route
              path="/*"
              element={<Navigate to={onboardingData.path || "verify-otp"} />}
            />
          </>
        ) : user ? (
          <>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/questions" element={<Questions />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/demos" element={<Demos />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/coverage" element={<Coverage />} />
            <Route path="/account" element={<Account />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/book-n-pendrive" element={<BookNPendrive />} />
            <Route path="/subscription" element={<Subscriptions />} />
            <Route path="/add-subscription" element={<AddSubscription />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </>
        ) : (
          <>
            <Route path="/" element={<SignIn />} />
            <Route path="/login" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
};
export default RouteFile;
